export const API_URL = "/backend";
